import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  container: {
    height: "80vh",
  },
  title: {
    margin: "1rem 0",
  },
  dataInput: {
    marginBottom: 2,
  },
  table: {
    backgroundColor: "#ddd",
  },
  tableCell: {
    width: "50%",
    padding: 0,
  },
  tableContainer: {
    maxHeight: "240px",
    overflowY: "auto",
  },
  buttonArea: {
    width: "100%",
    justifyContent: "space-between",
  },
};
